import { Component, Input, ElementRef, AfterViewInit, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import embed from 'vega-embed';

@Component({
    selector: 'app-vega-chart',
    template: `<div #container class="vega-container"></div>`,
    styles: [`
    .vega-container {
      width: 100%;
      min-height: 200px;
    }
    :host ::ng-deep .vega-embed {
      width: 100%;
    }
    :host ::ng-deep .vega-embed .chart-wrapper {
      width: 100%;
    }
  `],
    standalone: false
})
export class VegaChartComponent implements AfterViewInit, OnChanges {
  @Input() spec: any;
  @ViewChild('container', { static: true }) container!: ElementRef;

  private rendered = false;

  ngAfterViewInit(): void {
    this.renderChart();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['spec'] && !changes['spec'].firstChange) {
      this.renderChart();
    }
  }

  private async renderChart(): Promise<void> {
    if (!this.spec || !this.container) return;

    try {
      const specObj = typeof this.spec === 'string' ? JSON.parse(this.spec) : this.spec;

      // Detect theme from document
      const isDark = document.documentElement.getAttribute('data-theme') === 'dark' ||
                     document.body.classList.contains('dark-theme');

      await embed(this.container.nativeElement, specObj, {
        actions: {
          export: true,
          source: false,
          compiled: false,
          editor: false
        },
        theme: isDark ? 'dark' : 'vox'
      });

      this.rendered = true;
    } catch (error) {
      console.error('Failed to render Vega chart:', error);
      this.container.nativeElement.innerHTML = `<p class="error">Failed to render chart: ${error}</p>`;
    }
  }
}
